'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint camelcase: 0 */

var request  = require('./request'),
    prepareUrl = require('./prepareUrl'),
    Video = require('./video');


function Provider () {
    this.requestLinks = {};
}


/**
 * Get videos list.
 *
 * @param {Object} config - request config
 * @param {Function} callback - result handler
 */
Provider.prototype.getList = function ( config, callback ) {
    config = config || {};
    config.offset = config.offset || 0;
    config.limit = config.limit || 7;

    request(
        prepareUrl('movies', config),
        {
            method: 'GET',
            onload: function ( error, response ) {
                var data = [];

                if ( !error ) {
                    response.data.forEach(function ( item ) {
                        data.push(new Video(item));
                    });
                }

                callback(error, data, error ? 0 : response.paging.total);
            },
            onerror: callback
        },
        'getList',
        this.requestLinks
    );
};


/**
 * Get categories list.
 *
 * @param {Function} callback - result handler
 */
Provider.prototype.getCategories = function ( callback ) {
    request(
        'movie-categories?fields=name,id&limit=200',
        {
            method: 'GET',
            onload: callback,
            onerror: callback
        },
        'getCategories',
        this.requestLinks
    );
};

/**
 * Get genres list.
 *
 * @param {Function} callback - result handler
 */
Provider.prototype.getGenres = function ( callback ) {
    request(
        'movie-genres?limit=200',
        {
            method: 'GET',
            onload: function ( error, response ) {
                var index = 0,
                    names = [],
                    data;

                if ( !error ) {
                    data = response.data;
                    for ( index; index < data.length; index++ ) {
                        if ( names.indexOf(data[index].name) === -1 ) {
                            names.push(data[index].name);
                        } else {
                            data.splice(index, 1);
                            index--;
                        }
                    }
                }

                callback(error, response);
            },
            onerror: callback
        },
        'getGenres',
        this.requestLinks
    );
};

Provider.prototype.getSections = function ( callback ) {
    request(
        'movie-sections?limit=200',
        {
            method: 'GET',
            onload: callback,
            onerror: callback
        },
        'getSections',
        this.requestLinks
    );
};


module.exports = Provider;
